import resources from "@/utils/translations";
import { i18n as uii18n } from "@thetreep/ui";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const supportedLanguages = ["fr", "en"];
const browserLanguage = navigator.language.split("-")[0];

// Retrieve language from localStorage or fallback to browser language
const savedLanguage = localStorage.getItem("preferredLanguage");
const languageToUse = savedLanguage
  ? savedLanguage
  : supportedLanguages.includes(browserLanguage)
    ? browserLanguage
    : "fr";

// Listen for language changes and persist them
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("preferredLanguage", lng); // Save the selected language
  uii18n.changeLanguage(lng);
});

uii18n.addResourceBundle(
  "fr",
  "translation",
  { no_data: "Aucune donnée" },
  true,
  true,
);
uii18n.addResourceBundle(
  "en",
  "translation",
  { no_data: "No data" },
  true,
  true,
);

i18n.use(initReactI18next).init({
  resources,
  lng: languageToUse,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
